export default __webpack_public_path__ + "static/media/gol.49d7d44d.svg";